<template>
  <div class="order-submission">
    <div class="line">
      <img src="@assets/images/line.jpg" />
    </div>
    <div class="address acea-row row-between-wrapper" @click="addressTap">
      <div class="addressCon" v-if="addressInfo.real_name">
        <div class="name">
          {{ addressInfo.real_name }}
          <span class="phone">{{ addressInfo.phone }}</span>
        </div>
        <div>
          <span class="default font-color-red" v-if="addressInfo.is_default"
            >[默认]</span
          >
          {{ addressInfo.province }}{{ addressInfo.city
          }}{{ addressInfo.district }}{{ addressInfo.detail }}
        </div>
      </div>
      <div class="addressCon" v-else>
        <div class="setaddress">设置收货地址</div>
      </div>
      <div class="iconfont icon-jiantou"></div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo" :couponsList='couponsList'></OrderGoods>
    <div class="wrapper">
      <div
        class="item acea-row row-between-wrapper"
        @click="couponTap"
        v-show="false"
        v-if="deduction === false"
      >
        <div>优惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "请选择" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <!-- <div class="item acea-row row-between-wrapper" v-if="deduction === false">
        <div>积分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  当前积分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>-->
      <div class="item acea-row row-between-wrapper">
        <div>快递费用</div>
        <div class="discount">
          {{
            orderGroupInfo.priceGroup.storePostage > 0
              ? orderGroupInfo.priceGroup.storePostage
              : "免运费"
          }}
        </div>
      </div>
      <div class="item" v-if="false">
        <div>备注信息</div>
        <textarea
          placeholder="请添加备注（150字以内）"
          v-model="mark"
        ></textarea>
      </div>
    </div>
    <!-- <div class="wrapper" v-if='couponsList[0].cid >= 4386 && couponsList[0].cid <= 4485 && userInfo.now_money == 0.00'> -->
    <div class="wrapper" v-if='(couponsList && couponsList[0] && couponsList[0].coupon_type == 2) '>
      <div class="item">
        <div>支付方式</div>
        <div class="list">

          <!-- 次券过期 -->
          <div class="payItem acea-row row-middle" v-if="couponsList[0] && (couponsList[0]._msg == '已过期')">
            <div class="movie-box page-text-center">您的点券已过期,无法完成兑换</div>
          </div>
          <!-- 次券卡内余额为0 -->
          <div class="payItem acea-row row-middle" v-else-if="userInfo.now_money == 0.00">
            <div class="movie-box page-text-center">您的兑换次数已用完</div>
          </div>
          <!-- 次券选购商品金额>余额 -->
          <div class="payItem acea-row row-middle" v-else-if="userInfo.now_money != 0.00 && (orderPrice.pay_price > userInfo.now_money)">
              <div class="movie-box page-text-center">您选择的商品已超出兑换次数</div>
          </div>

          <div class="payItem acea-row row-middle on" :class="active === 'yue' ? 'on' : ''" @click="payItem('yue')" v-else>
            <div class="name acea-row row-center-wrapper">
              <div class="iconfont icon-icon-test" :class="active === 'yue' ? 'bounceIn' : ''"></div>
              点券支付
            </div>
          </div>

        </div>
      </div>
    </div>

<!-- 区间不使用微信支付用户 -->
    <div class="wrapper" v-else-if='isNotWechat'>
      <div class="item" v-if="orderPrice.pay_price <= userInfo.now_money">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle on"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              点券支付
            </div>
            <div class="tip">可用点券：{{ userInfo.now_money || 0 }}</div>
          </div>
        </div>
      </div>
      <div v-else>
          <div class="payItem acea-row row-middle">
            <div class="movie-box page-text-center">您选择的商品已超出兑换次数</div>
          </div>
      </div>
    </div>
<!-- 正常 -->
    <div class="wrapper" v-else>
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
            v-if="false"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="!isWeixin"
            v-if="false"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle on"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
            v-if="orderPrice.pay_price <= userInfo.now_money"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              点券支付
            </div>
     <!-- <div class="wrapper" v-if='couponsList[0].cid >= 4386 && couponsList[0].cid <= 4485'> -->
          <div class="wrapper" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'></div>
          <div class="tip" v-else>可用点券：{{ userInfo.now_money || 0 }}</div>
          </div>
          <div v-else>
            <div
              class="payItem acea-row row-middle on"
              :class="active === 'weixin' ? 'on' : ''"
              @click="payItem('weixin')"
            >
              <div class="name acea-row row-center-wrapper">
                <div
                  class="iconfont icon-icon-test"
                  :class="active === 'zh' ? 'bounceIn' : ''"
                ></div>
                组合支付
              </div>
              <div class="tip">微信支付点券不足金额</div>
            </div>
            <div v-if="couponsList && couponsList[0] && (couponsList[0].coupon_type == 2)"></div>
            <div
              class="tip kydq"
              :style="{ color: '#999', 'margin-top': '10px' }"
              v-else
            >
              可用点券：{{ userInfo.now_money || 0 }}
            </div>
          </div>

          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="offlinePayStatus === 1 && deduction === false"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              线下支付
            </div>
            <div class="tip">线下方便支付</div>
          </div>
        </div>
      </div>
    </div>

     <!-- <div class="wrapper" v-if='couponsList[0].cid >= 4386 && couponsList[0].cid <= 4485'> -->
     <div class="wrapper" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'></div>
     <div class="moneyList" v-else>
      <div class="item acea-row row-between-wrapper" v-if="orderPrice.total_price !== undefined">
        <div>商品总价：</div>
        <div class="money">{{ orderPrice.total_price }}</div>
      </div>

      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.pay_postage > 0"
      >
        <div>运费：</div>
        <div class="money">{{ orderPrice.pay_postage }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-show="false"
        v-if="orderPrice.coupon_price > 0"
      >
        <div>优惠券抵扣：</div>
        <!-- 优惠券抵扣显示商品总价金额，如果优惠券不足，显示可以抵扣的数量 -->
        <div class="money"></div>
        <div
          class="money"
          v-if="orderPrice.coupon_price >= orderPrice.total_price"
        >
          -{{ orderPrice.total_price }}
        </div>
        <div class="money" v-else>-{{ orderPrice.coupon_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deduction_price > 0"
      >
        <div>积分抵扣：</div>
        <div class="money">-{{ orderPrice.deduction_price }}</div>
      </div>
    </div>
    <div style="height:1.2rem"></div>
    <div class="donotTitle" v-if="donotTitle">{{donotTitle}}</div>
    <!-- 不发货地区 -->
    <div class="footer acea-row row-between-wrapper" v-if="donotDeliverGoods()">
      <div class="wrapper" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'>

        <div v-if='(orderGroupInfo.cartInfo && orderGroupInfo.cartInfo.length >= 2) || (orderGroupInfo.cartInfo && orderGroupInfo.cartInfo[0] && orderGroupInfo.cartInfo[0].cart_num >= 2)'>

          <span class="font-color-red">已超出兑换数</span>

        </div>
        <div v-else>

          可兑换数：<span class="font-color-red">{{ orderGroupInfo.cartInfo && orderGroupInfo.cartInfo.length }}</span>件
        </div>

        </div>

      <div v-else>
        合计:
        <span class="font-color-red">{{ orderPrice.pay_price }}</span>
        <!-- <span class="font-color-red" v-if="userInfo.now_money >= orderPrice.pay_price">0</span>
        <span class="font-color-red" v-else>{{orderPrice.pay_price - userInfo.now_money }}</span>-->
      </div>
        <div class="settlement" style="background-color:#999;" >立即兑换</div>
    </div>
<!-- / -->
    <div class="footer acea-row row-between-wrapper" v-else>
        <!-- <div class="wrapper" v-if='couponsList[0].cid >= 4386 && couponsList[0].cid <= 4485'> -->
        <div class="wrapper" v-if='couponsList[0] && (couponsList[0].coupon_type == 2)'>

        <div v-if='(orderGroupInfo.cartInfo && orderGroupInfo.cartInfo.length >= 2) || (orderGroupInfo.cartInfo && orderGroupInfo.cartInfo[0] && orderGroupInfo.cartInfo[0].cart_num >= 2)'>

          <span class="font-color-red">已超出兑换数</span>

        </div>
        <div v-else>

          可兑换数：<span class="font-color-red">{{ orderGroupInfo.cartInfo && orderGroupInfo.cartInfo.length }}</span>件
        </div>

        </div>

      <div v-else>
        合计:
        <span class="font-color-red">{{ orderPrice.pay_price }}</span>
        <!-- <span class="font-color-red" v-if="userInfo.now_money >= orderPrice.pay_price">0</span>
        <span class="font-color-red" v-else>{{orderPrice.pay_price - userInfo.now_money }}</span>-->
      </div>

<!-- <div v-if="couponsList[0].cid >= 4386 && couponsList[0].cid <= 4485"> -->
<div v-if="couponsList[0] && (couponsList[0].coupon_type == 2)">
<!-- coupon_type == 2 是次券 -->

  <!-- 过期 -->
  <div v-if="couponsList[0] && (couponsList[0]._msg == '已过期')">
    <div class="settlement" style="background-color:#999;" @click="openTip('此券已过期！')">立即兑换</div>
  </div>

  <div v-else-if="userInfo.now_money == 0.00">
    <!-- 次券余额为0 -->
    <div class="wrapper" v-if='((couponsList[0] && couponsList[0].coupon_type == 2) && userInfo.now_money == 0.00)'>
        <div class="settlement" style="background-color:#999;" >立即兑换</div>
    </div>
  </div>

  <!-- 余额不为0 -->
  <div v-else>
    <!-- 数量大于2 -->
    <div v-if='(orderGroupInfo.cartInfo && orderGroupInfo.cartInfo.length >= 2) || (orderGroupInfo.cartInfo && orderGroupInfo.cartInfo[0] && orderGroupInfo.cartInfo[0].cart_num >= 2)'>
      <div class="settlement" style="background-color:#999;" >立即兑换</div>
    </div>
    <!-- 商品价格大于点券余额 -->
    <div v-else-if="orderPrice.pay_price > userInfo.now_money">
      <div class="settlement" style="background-color:#999;" >立即兑换</div>
    </div>
    <div v-else>
        <div class="settlement" @click="createOrder" >立即兑换</div>
    </div>
  </div>
</div>
<div v-else>
  <div class="settlement" style="background-color:#999;" @click="openTip('点券已过期！')" v-if="couponsList[0] && (couponsList[0]._msg == '已过期')">立即兑换</div>
    <div class="settlement" @click="createOrder" v-else-if="orderPrice.pay_price <= userInfo.now_money && isNotWechat">立即兑换</div>
    <div class="settlement" @click="openTip('您选择的商品已超过兑换上限!')" style="background-color:#999;" v-else-if="orderPrice.pay_price > userInfo.now_money && isNotWechat">立即兑换</div>
    <div class="settlement" @click="createOrder" v-else>立即兑换</div>
</div>
    </div>

    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>
<script>
import { getUser, getMenuUser, getLogout, getCouponsUser } from "@api/user";

import OrderGoods from "@components/OrderGoods";
import CouponListWindow from "@components/CouponListWindow";
import AddressWindow from "@components/AddressWindow";
import {
  postOrderConfirm,
  postOrderComputed,
  createOrder,
  getOrderCoupon
} from "@api/order";
import { mapGetters } from "vuex";
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";

const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow
  },
  props: {},
  data: function() {
    return {
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: _isWeixin ? "weixin" : "yue",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: { coupon_title: "不使用优惠券", id: 0 },
      addressLoaded: false,
      useIntegral: false,
      orderPrice: {
        pay_price: "计算中"
      },
      mark: "",
      num1: 0,
      num2: 0,
      timePrice: null,
      endTime: [],
      gqmes: "",
      userInfo:{},
      couponsList:[],
      donotTitle: null, //部分地区不发货提示
      donotGoods: [
        // 874,439,401,306,313,411,748,608,791,276,306, 224,449,502,505,536,556,559,725,727,834
      ], //不发货商品id
      //
      donotTitleList: [
        // {type: 1, title: "该商品在该地区暂不支持销售，非常抱歉！"},
        {type: 2, title: "您选择的区域暂不提供发货，望您理解，请选择其他收货地址进行下单。"}
      ],
      notRegions: [ //注意这个跟shop不一样，不带省字，直辖市为省级
        {province: "台湾",type: 2}, 
        // {province: "香港特别行政区",type: 1}, 
        // {province: "澳门特别行政区",type: 1,city:[]}, 
        {province: "港澳",type: 2,city:[
          {city:"澳门特别行政区"},
          {city:"香港特别行政区"},
        ]},
        {province: "西藏",type: 2,city:[]}, 
        {province: "新疆",type: 2,city:[]}, 
        // {province: "广东省", type: 2,city: [
        //     {city:"佛山市",district: [{district:"南海区"}]},
        //     {city:"广州市",district: [{district:"荔湾区"}, {district: "越秀区"}]},
        //     {city:"深圳市",district: [{district:"龙岗区"}]}
        // ]},
        // {province: "辽宁省",type: 2,city: [
        //     {city:"营口市",district: [{district:"鲅鱼圈区"}]},]},
        // {province: "安徽省",type: 2,city: [
        //     {city:"六安市"}]}, 
        {province: "宁夏",type: 2}, 
        {province: "青海",type: 2},
        {province: "内蒙古",type: 2,city: [
          {city:"锡林郭勒盟", district: [{district:"二连浩特市"}]},
          {city:"阿拉善盟", district: [{district:"额济纳旗"}]},
          {city:"呼伦贝尔市", district: [{district:"满洲里市"}]}
          ]},
        // {province: "甘肃",type: 2,city: [
        //   {city:"酒泉市", district: [{district:"肃北县"}]}
        // ]},
        // {province: "河北",type: 2,city: [
        //   {city:"廊坊市", district: [{district:"大厂县"}]}
        // ]},
        // {province: "贵州",type: 2,city: [
        //   {city:"遵义市", district: [{district:"仁怀市"}]}
        // ]},
        // {province: "黑龙江",type: 2,city: [
        //   {city:"黑河市"}
        // ]},
        // {province: "辽宁",type: 2,city: [
        //   {city:"大连市"}
        // ]},
        // {province: "上海",type: 2,city: [ //直辖市=省级 特例
        //   {city:"青浦区"},{city:"嘉定区"}
        // ]},
        // {province: "河南",type: 2,city: [
        //   {city:"周口市", district: [{district:"扶沟县"}]}
        // ]},
      ],
      isNotWechat: false, // 余额不足时-不使用微信/组合支付 
      notWechatArray: [
        { minCoupon: 80016667, maxCoupon: 80017176 },
        { minCoupon: 60000586, maxCoupon: 60001235 }
      ]
    };
  },
  // computed: mapGetters(["userInfo"]),
  watch: {
    useIntegral() {
      this.computedPrice();
    },
    $route(n) {
      if (n.name === NAME) this.getCartInfo();
    }
  },
  mounted: async function() {
    // console.log(this.usableCoupon.id);
    await getCouponsUser(0).then(res => {
      this.couponsList = res.data;
    });
    var that = this;
    await this.getCartInfo();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
  },
  methods: {
    openTip(title){
      if (title) {
        this.$dialog.error(title);
      } else {
        this.$dialog.error("已超过兑换数量！");
      }
    },
    donotDeliverGoods: function () {
      let dont = false;
      this.notRegions.forEach((item)=>{

        // 省
        if (item.province && (!item.city || (item.city && item.city.length == 0))) {
          if ( item.province == this.addressInfo.province ) {
            
            dont = true;
            this.donotTitleList.forEach((dt)=>{
              if (item.type == dt.type) {
                this.donotTitle = dt.title;
              }
            })
          }
        }
        // 市 区
        if (item.province && item.city && item.city.length !== 0) {
          if ( item.province == this.addressInfo.province ) {
            item.city.forEach((val)=>{
              //市
              if (val.city == this.addressInfo.city && (!val.district || (val.district && val.district.length == 0))) {
                 dont = true;
                 this.donotTitleList.forEach((dt)=>{
                  if (item.type == dt.type) {
                    this.donotTitle = dt.title;
                  }
                })
              }
              //区
              if (val.city == this.addressInfo.city && (val.district && val.district.length !== 0)) {
                 val.district.forEach((ind)=>{
                    if (ind.district == this.addressInfo.district) {
                      dont = true;
                      this.donotTitleList.forEach((dt)=>{
                        if (item.type == dt.type) {
                          this.donotTitle = dt.title;
                        }
                      })
                    }
                 })
              }
            })
          }
        }
      });
      if (!dont) {
        this.donotTitle = "";
      }
      return dont;
    },
    computedPrice() {
      // 这里修改了不使用优惠券
      this.usableCoupon.id = 0;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0
      }).then(res => {
        const data = res.data;
        if (data.status === "EXTEND_ORDER") {
          this.$router.replace({
            path: "/order/detail/" + data.result.orderId
          });
        } else {
          this.orderPrice = data.result;
        }
      }).catch((err)=>{
        this.$dialog.error(err.msg);
      });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("参数有误");
        return this.$router.go(-1);
      }

      postOrderConfirm(cartIds)
        .then(res => {
          this.userInfo = res.data.userInfo
          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};

          // this.donotTitle = null;
          // if (res.data.addressInfo && res.data.addressInfo.province && res.data.addressInfo.province == "北京") {
          //   res.data.cartInfo && res.data.cartInfo.forEach((resl)=>{

          //   if (resl.productInfo && resl.productInfo.id) {
          //       this.donotGoods.forEach((dt)=>{
          //         if (resl.productInfo.id == dt) {
          //           this.donotTitle = "受交通管制影响，此商品北京区域物流暂停，7月5日后恢复正常发货，望您谅解。";
          //         }
          //       })
          //   } 
          //   })
          // }

          //另一种限制：余额不足不使用微信支付
          let user_id = res.data.userInfo  && res.data.userInfo.uname;
          let isTrue = false;
          for(let i = 0; i < this.notWechatArray.length; i++) {
            if (user_id >= this.notWechatArray[i].minCoupon && user_id <= this.notWechatArray[i].maxCoupon) {
              isTrue = true;
            } else if ( user_id == 60001235 || user_id == 60001234 ) {
              isTrue = true;
            }
          }
          if (isTrue) {
            this.isNotWechat = true;
          } else {
            this.isNotWechat = false;
          }

          this.computedPrice();
        })
        .catch(() => {
          this.$dialog.error("加载订单数据失败");
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      console.log(this.usableCoupon);
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用优惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;

      // if (addressInfo.province == "北京") {
      //   this.orderGroupInfo.cartInfo && this.orderGroupInfo.cartInfo.forEach((resl)=>{
      //     if (resl.productInfo && resl.productInfo.id) {
      //           this.donotGoods.forEach((dt)=>{
      //             if (resl.productInfo.id == dt) {
      //               this.donotTitle = "受交通管制影响，此商品北京区域物流暂停，7月5日后恢复正常发货，望您谅解。";
      //             }
      //           })
      //       } 
      //   })
      // } else {
      //   this.donotTitle = null;
      // }

    },
    createOrder() {
      if (!this.active) return this.$dialog.toast({ mes: "请选择支付方式" });
      if (!this.addressInfo.id)
        return this.$dialog.toast({ mes: "请选择收货地址" });

      // 这里做的判断 -- 过不过期
      // function formatDate(now) {
      //   var year = now.getFullYear();
      //   var month = now.getMonth() + 1;
      //   var date = now.getDate();
      //   return year + "/" + month + "/" + date;
      // }
      // this.timePrice = formatDate(new Date());

      // getOrderCoupon(this.orderPrice.pay_price).then(res => {
      //   this.endTime = res.data;
      //   console.log(this.endTime[0].end_time);
      //   console.log(this.timePrice);
      //   // 这里要改为>
      //   if (this.endTime[0].end_time > this.timePrice) {
      //     //console.log("已经过了使用期限")
      //     //alert('已经过了使用期限')
      //     this.$dialog.error("点券已失效，请先充值或激活");
      //     setTimeout(() => {
      //       this.$router.push("/user/account");
      //     }, 1500);
      //     return false;
      //   }
      // });

      // if(this.active == "zh"){
      //   this.$dialog.toast({ mes: "暂未开通，敬请期待" });
      // }

      // setTimeout(()=>{
      //   this.$router.push('/')
      // },2000)

      this.$dialog.confirm({
        mes: "确认兑换?",
        opts: () => {
          this.$dialog.loading.open("生成订单中");
          if (this.orderPrice.pay_price <= this.userInfo.now_money) {
            this.active = "yue";
          } else if (this.orderPrice.pay_price > this.userInfo.now_money) {
            this.active = "weixin";
          }
          if (this.isNotWechat) { //是否为不可用微信支付区间用户
            this.active = "yue";
          }
          createOrder(this.orderGroupInfo.orderKey, {
            addressId: this.addressInfo.id,
            useIntegral: this.useIntegral ? 1 : 0,
            couponId: this.usableCoupon.id || 0,
            payType: this.active,
            pinkId: this.pinkId,
            seckill_id: this.orderGroupInfo.seckill_id,
            combinationId: this.orderGroupInfo.combination_id,
            bargainId: this.orderGroupInfo.bargain_id,
            from: this.from,
            mark: this.mark || ""
          })
            .then(res => {
              this.$dialog.loading.close();
              const data = res.data;
              switch (data.status) {
                case "ORDER_EXIST":
                case "EXTEND_ORDER":
                case "PAY_DEFICIENCY":
                case "PAY_ERROR":
                  this.$dialog.toast({ mes: res.msg });
                  this.$router.replace({
                    path: "/user"
                  });
                  break;
                case "SUCCESS":
                  this.$dialog.success(res.msg);
                  this.$router.replace({
                    path: "/user"
                  });
                  break;
                case "WECHAT_H5_PAY":
                  this.$router.replace({
                    path: "/user"
                  });
                  setTimeout(() => {
                    location.href = data.result.jsConfig.mweb_url;
                  }, 100);
                  break;
                case "WECHAT_PAY":
                  pay(data.result.jsConfig).finally(() => {
                    this.$router.replace({
                      path: "/user"
                    });
                  });
              }
            })
            .catch(err => {
              console.log(err);
              this.$dialog.loading.close();
              this.$dialog.error(err.msg || "创建订单失败");
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.order-submission {
  padding-bottom: 1.14rem;
}
.donotTitle {
  color: rgb(244, 69, 69);
  background-color: rgb(255, 230, 230);
  text-align: center;
  margin: 0px auto;
  padding: 0.15rem;
  bottom: 1rem;
  position: fixed;
  width: 100%;
}
</style>